"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: 'Zeit auswählen'
};
var _default = locale;
exports["default"] = _default;